// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://iyulmbnyszoehwxdrkcr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml5dWxtYm55c3pvZWh3eGRya2NyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxOTcxMDMsImV4cCI6MjA1Nzc3MzEwM30.gSQw3_ALNKN8h9mUJ5aD3ro_z9S1I0947dh8fRrHI_c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);